import React from "react";
import "./_qokr-banner.scss";

// One-line notice above a page or section. `tone`: info | success | warn.
const QokrBanner = ({ tone = "info", icon, title, children, action }) => (
  <div className={`qokr-banner qokr-banner--${tone}`} role="status">
    {icon ? (
      <span className="qokr-banner__icon">
        <i className={icon} aria-hidden="true" />
      </span>
    ) : null}
    <div className="qokr-banner__body">
      {title ? <div className="qokr-banner__title">{title}</div> : null}
      {children ? <div className="qokr-banner__text">{children}</div> : null}
    </div>
    {action ? <div className="qokr-banner__action">{action}</div> : null}
  </div>
);

export default QokrBanner;
